<template>
  <footer class="site-footer">

    <!-- Animated Particles Canvas -->
    <canvas ref="particlesCanvas" class="particles-canvas"></canvas>

    <!-- Main Footer Content -->
    <div class="footer-main">
      <v-container class="footer-container">

        <v-row>

          <!-- Company Info -->
          <v-col cols="12" md="4" lg="4">
            <div class="footer-section company-section">
              <div class="footer-logo">
                <div class="logo-container">
                  <v-img src="logo.png" max-width="200" max-height="80" contain class="logo-img"></v-img>
                </div>
              </div>
              <p class="company-tagline">
                Innovating Digital Solutions for Tomorrow's Challenges
              </p>
              <p class="company-description">
                We craft cutting-edge software solutions that transform businesses and drive digital innovation across
                the globe.
              </p>

              <!-- Social Media -->
              <div class="social-links">
                <a href="#" class="social-link" aria-label="LinkedIn">
                  <v-icon color="#ffffff">mdi-linkedin</v-icon>
                </a>
                <a href="#" class="social-link" aria-label="Twitter">
                  <v-icon color="#ffffff">mdi-twitter</v-icon>
                </a>
                <a href="#" class="social-link" aria-label="Facebook">
                  <v-icon color="#ffffff">mdi-facebook</v-icon>
                </a>
                <a href="#" class="social-link" aria-label="Instagram">
                  <v-icon color="#ffffff">mdi-instagram</v-icon>
                </a>
                <a href="#" class="social-link" aria-label="GitHub">
                  <v-icon color="#ffffff">mdi-github</v-icon>
                </a>
              </div>
            </div>
          </v-col>

          <!-- Quick Links -->
          <v-col cols="6" sm="6" md="2" lg="2">
            <div class="footer-section">
              <h3 class="footer-heading">Company</h3>
              <ul class="footer-links">
                <li><a href="/about">About Us</a></li>
                <li><a href="/team">Our Team</a></li>
                <li><a href="/careers">Careers</a></li>
                <li><a href="/portfolio">Portfolio</a></li>
                <li><a href="/testimonials">Testimonials</a></li>
              </ul>
            </div>
          </v-col>

          <!-- Services -->
          <v-col cols="6" sm="6" md="2" lg="2">
            <div class="footer-section">
              <h3 class="footer-heading">Services</h3>
              <ul class="footer-links">
                <li><a href="/services/mobile">Mobile Apps</a></li>
                <li><a href="/services/web">Web Development</a></li>
                <li><a href="/services/ai">AI Solutions</a></li>
                <li><a href="/services/design">UI/UX Design</a></li>
                <li><a href="/services/cloud">Cloud Services</a></li>
              </ul>
            </div>
          </v-col>

          <!-- Resources -->
          <v-col cols="6" sm="6" md="2" lg="2">
            <div class="footer-section">
              <h3 class="footer-heading">Resources</h3>
              <ul class="footer-links">
                <li><a href="/blog">Blog</a></li>
                <li><a href="/case-studies">Case Studies</a></li>
                <li><a href="/documentation">Documentation</a></li>
                <li><a href="/support">Support</a></li>
                <li><a href="/faq">FAQ</a></li>
              </ul>
            </div>
          </v-col>

          <!-- Contact Info -->
          <v-col cols="6" sm="6" md="2" lg="2">
            <div class="footer-section">
              <h3 class="footer-heading">Contact</h3>
              <ul class="footer-contact">
                <li>
                  <v-icon size="16" color="#5ce1e6">mdi-phone</v-icon>
                  <span>+91 97448 33812</span>
                </li>
                <li>
                  <v-icon size="16" color="#5ce1e6">mdi-email</v-icon>
                  <span>info@cybercraft.com</span>
                </li>
                <li>
                  <v-icon size="16" color="#5ce1e6">mdi-map-marker</v-icon>
                  <span>Kottayam, Kerala</span>
                </li>
              </ul>
            </div>
          </v-col>

        </v-row>

        <!-- Newsletter Section -->
        <div class="newsletter-section">
          <v-row align="center">
            <v-col cols="12" md="6">
              <h3 class="newsletter-title">Subscribe to Our Newsletter</h3>
              <p class="newsletter-text">Get the latest updates, insights, and exclusive offers delivered to your inbox.
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="newsletter-form">
                <v-text-field v-model="email" placeholder="Enter your email" outlined dense hide-details color="#5ce1e6"
                  class="email-input">
                  <template v-slot:append>
                    <v-btn elevation="0" class="subscribe-btn" @click="subscribe">
                      Subscribe
                      <v-icon right small>mdi-send</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>

      </v-container>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <v-container class="footer-container">
        <div class="bottom-content">
          <div class="copyright">
            <span>© {{ currentYear }} Cyber Craft Innovations. All rights reserved.</span>
          </div>
          <div class="bottom-links">
            <a href="/privacy">Privacy Policy</a>
            <span class="divider">•</span>
            <a href="/terms">Terms of Service</a>
            <span class="divider">•</span>
            <a href="/cookies">Cookie Policy</a>
          </div>
        </div>
      </v-container>
    </div>

  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      email: '',
      currentYear: new Date().getFullYear(),
      particles: [],
      animationId: null
    };
  },
  mounted() {
    this.initParticles();
    this.animateParticles();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    subscribe() {
      console.log('Subscribe email:', this.email);
      // Add subscription logic here
      this.email = '';
    },

    initParticles() {
      const canvas = this.$refs.particlesCanvas;
      if (!canvas) return;

      canvas.width = canvas.parentElement.offsetWidth;
      canvas.height = canvas.parentElement.offsetHeight;

      const particleCount = 40;
      this.particles = [];

      for (let i = 0; i < particleCount; i++) {
        this.particles.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 2 + 0.5,
          speedX: (Math.random() - 0.5) * 0.2,
          speedY: (Math.random() - 0.5) * 0.2,
          opacity: Math.random() * 0.3 + 0.1
        });
      }
    },

    animateParticles() {
      const canvas = this.$refs.particlesCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      this.particles.forEach((particle, i) => {
        particle.x += particle.speedX;
        particle.y += particle.speedY;

        if (particle.x < 0) particle.x = canvas.width;
        if (particle.x > canvas.width) particle.x = 0;
        if (particle.y < 0) particle.y = canvas.height;
        if (particle.y > canvas.height) particle.y = 0;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(92, 225, 230, ${particle.opacity})`;
        ctx.fill();

        this.particles.slice(i + 1).forEach(otherParticle => {
          const dx = particle.x - otherParticle.x;
          const dy = particle.y - otherParticle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 100) {
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(otherParticle.x, otherParticle.y);
            const opacity = (1 - distance / 100) * 0.1;
            ctx.strokeStyle = `rgba(92, 225, 230, ${opacity})`;
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        });
      });

      this.animationId = requestAnimationFrame(this.animateParticles);
    },

    handleResize() {
      const canvas = this.$refs.particlesCanvas;
      if (canvas) {
        canvas.width = canvas.parentElement.offsetWidth;
        canvas.height = canvas.parentElement.offsetHeight;
      }
    }
  }
};
</script>

<style scoped>
/* Import Inter Font */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

/* Site Footer */
.site-footer {
  position: relative;
  background: #000000;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

/* Particles Canvas */
.particles-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  opacity: 0.6;
}

/* Footer Main */
.footer-main {
  position: relative;
  z-index: 2;
  padding: 80px 0 60px;
  border-top: 1px solid rgba(92, 225, 230, 0.15);
}

.logo-container {
  padding: 24px 28px;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.95) 0%, 
    rgba(240, 250, 255, 0.9) 50%, 
    rgba(220, 245, 255, 0.85) 100%);
  border: 1px solid rgba(92, 225, 230, 0.3);
  border-radius: 14px;
  display: inline-block;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(92, 225, 230, 0.15);
  min-width: 220px;
}

.logo-img {
  filter: none !important;
  /* Keep original colors - no inversion needed */
}


.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
}

.footer-section {
  margin-bottom: 32px;
}

/* Company Section */
.company-section {
  max-width: 350px;
}

.footer-logo {
  margin-bottom: 24px;
}

.logo-img >>> img {
  object-fit: contain !important;
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
}

.company-tagline {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #5ce1e6;
  margin-bottom: 12px;
  line-height: 1.5;
}

.company-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 24px;
}

/* Social Links */
.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(92, 225, 230, 0.08);
  border: 1px solid rgba(92, 225, 230, 0.2);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: rgba(92, 225, 230, 0.15);
  border-color: #5ce1e6;
  transform: translateY(-4px);
}

/* Footer Headings */
.footer-heading {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Footer Links */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: #5ce1e6;
  transform: translateX(4px);
}

/* Footer Contact */
.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-contact li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.footer-contact span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

/* Newsletter Section */
.newsletter-section {
  margin-top: 60px;
  padding: 40px;
  background: rgba(92, 225, 230, 0.05);
  border: 1px solid rgba(92, 225, 230, 0.15);
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.newsletter-title {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
  letter-spacing: -0.02em;
}

.newsletter-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}

/* Newsletter Form */
.newsletter-form {
  display: flex;
}

.email-input {
  flex: 1;
}

.email-input>>>.v-input__control {
  background: rgba(255, 255, 255, 0.05) !important;
}

.email-input>>>fieldset {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.email-input:hover>>>fieldset {
  border-color: rgba(92, 225, 230, 0.3) !important;
}

.email-input.v-input--is-focused>>>fieldset {
  border-color: #5ce1e6 !important;
}

.email-input>>>input {
  color: #ffffff !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
}

.email-input>>>input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

.subscribe-btn {
  background: linear-gradient(135deg, #5ce1e6 0%, #4facfe 100%) !important;
  color: #000000 !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  text-transform: none;
  padding: 0 24px !important;
  height: 40px !important;
  border-radius: 0 4px 4px 0;
  transition: all 0.3s ease;
}

.subscribe-btn:hover {
  box-shadow: 0 8px 20px rgba(92, 225, 230, 0.4);
}

/* Footer Bottom */
.footer-bottom {
  position: relative;
  z-index: 2;
  padding: 28px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
}

.bottom-links {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bottom-links a {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
}

.bottom-links a:hover {
  color: #5ce1e6;
}

.divider {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
}

/* Responsive */
@media (max-width: 960px) {
  .footer-main {
    padding: 60px 0 40px;
  }

  .footer-container {
    padding: 0 40px;
  }

  .company-section {
    max-width: 100%;
  }

  .newsletter-section {
    padding: 32px 24px;
  }

  .newsletter-title {
    font-size: 20px;
  }

  .bottom-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 24px;
  }

  .footer-main {
    padding: 50px 0 30px;
  }

  .footer-section {
    margin-bottom: 24px;
  }

  .newsletter-section {
    padding: 24px 20px;
    margin-top: 40px;
  }

  .newsletter-form {
    margin-top: 20px;
  }

  .email-input>>>.v-input__append-inner {
    margin-top: 0 !important;
  }

  .subscribe-btn {
    padding: 0 16px !important;
    font-size: 13px;
  }

  .bottom-links {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .social-links {
    justify-content: flex-start;
  }

  .social-link {
    width: 40px;
    height: 40px;
  }

  .newsletter-form {
    flex-direction: column;
  }

  .subscribe-btn {
    width: 100%;
    border-radius: 4px;
    margin-top: 12px;
    height: 48px !important;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .particles-canvas {
    display: none;
  }
}
</style>
